export const goTop = {
    data(){
        return{
            scrollTop:0,
        }
    },
    mounted(){
        window.addEventListener('scroll', this.getScroll);
    },
    methods:{
        //滚动事件
        getScroll(){
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        },
        //滚动到顶部
        goTop(){
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                    clearInterval(timeTop);
                }
            }, 10);
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/goTop.js